import { QuestionCircleFilled } from "@ant-design/icons"
import { Checkbox, Tooltip } from "antd"
import TextArea from "antd/es/input/TextArea"
import { useEffect, useState } from "react"
import { t } from "../../../languages/i18n"

interface CodeProp {
  setGaCode: (gaCode: string) => void
  gaCode: string
}

const GoogleAnalyticsCode: React.FC<CodeProp> = ({ setGaCode, gaCode }) => {
  const [fillGA, setFillGa] = useState<boolean>(false)
  const [gaCodeInput, setGaCodeInput] = useState<string>()

  const handleChange = (e: any) => {
    setGaCodeInput(e.target.value)
    setGaCode(e.target.value)
  }
  useEffect(() => {
    setGaCodeInput(gaCode)
    if (gaCode) {
      setFillGa(true)
    }
  }, [gaCode])
  return (
    <div className="w-full flex flex-row gap-4 border-b pb-8">
      <div className="w-2/5 flex flex-col gap-2 ">
        <h2 className="text-base font-semibold">Google Analytics</h2>
        <p>{t("Paste the code or station account code GA4 provided by Google")}</p>
      </div>
      <div className=" w-3/5 flex flex-col gap-2 bg-white drop-shadow-md p-4 rounded-lg align-top">
        <div className="flex flex-row gap-2 items-center">
          <Checkbox checked={fillGA} onChange={() => setFillGa(!fillGA)}>
            Google Analytics V4
          </Checkbox>
          <Tooltip title="Hướng dẫn thiết lập">
            <QuestionCircleFilled style={{ fontSize: 18 }} />
          </Tooltip>
        </div>
        {fillGA && (
          <TextArea
            value={gaCodeInput || ""}
            onChange={handleChange}
            placeholder={t("Paste your GA4 code here (G-XXXXXXXX ...) ")}
            autoSize={{ minRows: 2, maxRows: 6 }}
          />
        )}
      </div>
    </div>
  )
}

export default GoogleAnalyticsCode
